import { render, staticRenderFns } from "./SMSJourney.vue?vue&type=template&id=7e5583e1&"
import script from "./SMSJourney.vue?vue&type=script&lang=ts&"
export * from "./SMSJourney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports